/** Recorded dates and available evidence are facts, never a legal cover opinion. */
export function recordedPolicyPeriod(period, today) {
    return today < period.startsOn ? 'Future recorded period' : today > period.endsOn ? 'Past recorded period' : 'Within recorded period';
}
//# sourceMappingURL=insurance-policy.js.map